<template>
    <div class="home">
        <div class="home-banners">
        <!--autoplay :autoplay-speed="5000"-->
            <Carousel v-model="index"  trigger="hover" :radius-dot="true">
                <CarouselItem v-for="(item, idx) in banners.list" :key="String(idx)">
                    <div class="demo-carousel">
                        <img :src="item.image"  />
                    </div>
                    <!--@click="jumpUrl(item.desc)" style="cursor:pointer;"-->
                </CarouselItem>
            </Carousel>
        </div>
        <div class="login-panel animate-fadein-up" v-if="!$store.state.token">
            <Modal
                    v-model="loginCheck"
                    title="提示"
                    ok-text="去下载"
                    @on-ok="goToDownload"
                    @on-cancel="goToDownloadCancel">
                <p>抱歉，为了更好的支持系统， 请更换chrome浏览器继续访问...</p>
<!--                <p><a href="https://wup-oss-1252338237.cos.ap-shanghai.myqcloud.com/api/20210325/3aa4a128e1dc43c693c90c9f1d7a27c8.exe?name=ChromeSetup.exe">点击下载</a></p>-->
            </Modal>
            <Card>
                <Tabs :value="tabSelected">
                    <TabPane label="登录" name="signin">
                        <Form ref="signin" :model="signin" :rules="signinRules">
                            <FormItem prop="username">
                                <i-input
                                        type="text"
                                        :readonly="loadingsSignin"
                                        v-model="signin.username"
                                        :maxlength="11"
                                        placeholder="手机号"
                                >
                                    <Icon type="ios-person-outline" slot="prepend"></Icon>
                                </i-input>
                            </FormItem>
                            <FormItem prop="password">
                                <i-input
                                        type="password"
                                        :readonly="loadingsSignin"
                                        v-model="signin.password"
                                        placeholder="密码"
                                >
                                    <Icon type="ios-lock-outline" slot="prepend"></Icon>
                                </i-input>
                            </FormItem>
                            <FormItem prop="captcha">
                                <Row>
                                    <i-col span="12">
                                        <i-input
                                                style="width: 90%"
                                                type="text"
                                                :readonly="loadingsSignin"
                                                v-model="signin.captcha"
                                                placeholder="验证码"
                                                @keydown.enter.native="enterLogin"
                                        />
                                    </i-col>
                                    <i-col span="12">
                                        <img :src="signin.captchaPath" style="overflow: hidden; width: 90%"
                                             @click="getCaptcha()" alt=""/>
                                    </i-col>
                                </Row>
                            </FormItem>
                            <FormItem>
                                <Button
                                        @click="handleSignin"
                                        type="primary"
                                        :loading="loadingsSignin"
                                        long
                                        id="loginBtn"
                                        style="background-color: #FAB95B;border-color: #FAB95B;"
                                >登录
                                </Button
                                >
                            </FormItem>
                        </Form>
                    </TabPane>
                    <TabPane label="注册" name="signup">
                        <Form
                                ref="signup"
                                :model="signup"
                                :rules="signupRules"
                                :label-width="70"
                                label-colon
                        >
                            <FormItem prop="username" label="手机号">
                                <i-input
                                        type="text"
                                        v-model="signup.username"
                                        :readonly="loadingsSignup"
                                        :maxlength="11"
                                        placeholder="手机号"
                                >
                                    <!-- <Icon type="ios-phone-portrait" slot="prepend"></Icon> -->
                                </i-input>
                            </FormItem>
                            <FormItem prop="nickName" label="昵称">
                                <i-input
                                        type="text"
                                        v-model="signup.nickName"
                                        :readonly="loadingsSignup"
                                        placeholder="昵称"
                                >
                                    <!-- <Icon type="ios-phone-portrait" slot="prepend"></Icon> -->
                                </i-input>
                            </FormItem>
                            <FormItem prop="realName" label="姓名">
                                <i-input
                                        type="text"
                                        v-model="signup.realName"
                                        :readonly="loadingsSignup"
                                        placeholder="姓名"
                                >
                                    <!-- <Icon type="ios-phone-portrait" slot="prepend"></Icon> -->
                                </i-input>
                            </FormItem>

                            <FormItem prop="password" label="密码">
                                <i-input
                                        type="password"
                                        :readonly="loadingsSignup"
                                        v-model="signup.password"
                                        placeholder="设置密码"
                                >
                                    <!-- <Icon type="ios-lock-outline" slot="prepend"></Icon> -->
                                </i-input>
                            </FormItem>
                            <FormItem prop="userType" label="类型">
                                <RadioGroup v-model="signup.userType">
                                    <Radio label="TEACHER">教师</Radio>
                                    <Radio label="STUDENT">学生</Radio>
                                </RadioGroup>
                            </FormItem>
                            <FormItem prop="code" label="验证码">
                                <i-input
                                        type="text"
                                        v-model="signup.code"
                                        :readonly="loadingsSignup"
                                        placeholder="验证码"
                                >
                                    <Icon type="ios-keypad-outline" slot="prepend"/>
                                    <Button
                                            v-if="successGetPhondeCode"
                                            size="small"
                                            type="text"
                                            slot="append"
                                            :loading="loadingVCode"
                                            @click="getVCode"
                                    >获取验证码
                                    </Button
                                    >
                                    <Button v-else size="small" type="text" slot="append"
                                    >{{ seconds }} 后重新获取
                                    </Button
                                    >
                                </i-input>
                            </FormItem>
                        </Form>
                        <Button
                                @click="handleSignup"
                                type="primary"
                                long
                                :loading="loadingsSignup"
                        >注册
                        </Button
                        >
                    </TabPane>
                </Tabs>
            </Card>
        </div>
        <section class="dj-container home-section bg-gray" v-if="teams.desc">
            <header>
<!--                <span class="section-title">教研团队</span>-->
                <span class="section-title">{{ teams.desc }}</span>
            </header>
            <div class="dj-container">
                <p class="section-desc">{{ teams.desc }}</p>
                <Carousel
                        v-model="teacherIndex"
                        trigger="hover"
                        dots="outside"
                        arrow="never"
                >
                    <CarouselItem>
                        <Row :gutter="16">
                            <i-col
                                    span="6"
                                    v-for="item in teams.list.slice(0, 4)"
                                    :key="item.name"
                            >
                                <div class="teacher transition">
                                    <img :src="item.image"/>
                                    <p class="teacher-name">{{ item.name }}</p>
                                    <p class="teacher-title">{{ item.title }}</p>
                                    <p class="teacher-desc" @click="onClickDesc(item.desc)">
                                        {{ item.desc }}
                                    </p>
                                </div>
                            </i-col>
                        </Row>
                    </CarouselItem>
                    <CarouselItem v-if="teams.list.length > 4">
                        <Row :gutter="16">
                            <i-col
                                    span="6"
                                    v-for="item in teams.list.slice(4, 8)"
                                    :key="item.name"
                            >
                                <div class="teacher transition">
                                    <img :src="item.image"/>
                                    <p class="teacher-name">{{ item.name }}</p>
                                    <p class="teacher-title">{{ item.title }}</p>
                                    <p class="teacher-desc">{{ item.desc }}</p>
                                </div>
                            </i-col>
                        </Row>
                    </CarouselItem>
                </Carousel>
            </div>
        </section>
        <section class="dj-container home-section bg-white"  v-if="c_supports.list[0].desc">
            <header>
<!--                <span class="section-title">课程支持</span>-->
                <span class="section-title">{{ c_supports.list[0].desc }}</span>
            </header>
            <div class="dj-container">
                <img class="w100" :src="c_supports.list[0].image"/>
            </div>
        </section>
        <section class="dj-container home-section bg-gray"  v-if="d_supports.list[0].desc">
            <header>
                <span class="section-title">{{ d_supports.list[0].desc }}</span>
<!--                <span class="section-title">硬件支持</span>-->
            </header>
            <div class="dj-container">
<!--                <p class="section-desc">{{ d_supports.list[0].desc }}</p>-->
                <video class="w100" :src="d_supports.list[0].video" controls
                       poster=" https://wup-oss-1252338237.cos.ap-shanghai.myqcloud.com/api/20210314/4160bce78a4a45509984ab8e802d3101.jpg?name=2.jpg"
                       controlslist="nodownload"
                       :disablePictureInPicture="true"></video>
            </div>
        </section>
        <section class="dj-container home-section bg-white" v-if=" t_mode.remark">
            <header>
<!--                <span class="section-title">教学方式</span>-->
                <span class="section-title">{{ t_mode.remark }}</span>
            </header>
            <div class="dj-container">
                <p class="section-desc">{{ t_mode.remark }}</p>
                <div class="d-flex wrap">
                    <div
                            class="w50 t_mode-images"
                            v-for="(item, idx) in t_mode.list"
                            :key="idx"
                    >
                        <img class="w100" :src="item.image"/>
                        <div style="margin-top: 10px">{{ item.title }}</div>
                        <div>{{ item.desc }}</div>
                    </div>
                </div>
            </div>
        </section>
        <section class="dj-container home-section bg-gray" v-if="t_system.list">
            <header>
                <span class="section-title">{{ t_mode.t_system }}</span>
            </header>
            <div class="dj-container">
                <div style="margin-top: 1rem">
                    <Button
                            style="width: 10px;height: 10px;border-color: #FAB95B"
                            type="primary"
                            v-for="(item, idx) in t_system.list"
                            :key="String(idx)"
                            @click="t_system_index = idx"
                    >{{ item.title }}
                    </Button
                    >
                </div>
                <Carousel v-model="t_system_index" dots="none" arrow="never">
                    <CarouselItem v-for="(item, idx) in t_system.list" :key="String(idx)">
                        <div>
                            <p class="section-desc">{{ item.desc }}</p>
                            <img style="width: 1200px;height: 800px" :src="item.image" class="w100"/>
                        </div>
                    </CarouselItem>
                </Carousel>
            </div>
        </section>
        <section class="dj-container home-section bg-white" v-if="cooperation_process.list[0].desc">
            <header>
<!--                <span class="section-title">合作流程</span>-->
                <span class="section-title">{{ cooperation_process.list[0].desc }}</span>
            </header>
            <div class="dj-container">
<!--                <p class="section-desc">{{ cooperation_process.list[0].desc }}</p>-->
                <img class="w100" :src="cooperation_process.list[0].image"/>
            </div>
        </section>
        <section class="dj-container home-section bg-gray" >
            <header>
                <span class="section-title">{{ t_mode.cooperation_case }}</span>
                
            </header>
            <div class="dj-container" >
<!--                <p class="section-desc">{{ cooperation_case.desc }}</p>-->
                <Row :gutter="12">
                    <i-col
                            span="8"
                            v-for="(item, idx) in cooperation_case.list"
                            :key="String(idx)"
                    >
                        <div
                                style="
                                background-color: #ffffff;
                                border-radius: 4px;
                                overflow: hidden;
                              "
                        >
                            <img class="cooperation_case_image" :src="item.image" alt=""/>
                        </div>
                    </i-col>
                </Row>
            <!--    <Carousel autoplay v-model="index" loop trigger="hover" >
                    <CarouselItem v-for="i in 2" :key="String(i)"  style="width: 1200px;height: auto">
                        <div class="cooperation_case_class">
                            <div
                                    v-for="(item, idx) in cooperation_case.list" :key="String(idx)"
                                    class="card-item_header&#45;&#45;image"
                                    :style="{ 'background-image': `url(${item.image})` }"
                            ></div>
                        </div>
                    </CarouselItem>
                </Carousel>-->
            </div>
        </section>
        <div class="home-side">
            <Tooltip placement="left" v-for="(item, index) in side.list" :key="index">
                <div slot="content" style="text-align: center">
                    <img
                            style="width: 100px; height: 100px"
                            :src="item.image"
                            alt=""
                            srcset=""
                    />
                    <div style="font-size: 12px">{{ item.desc }}</div>
                </div>
                <div class="side-item">
                    <img
                            style="width: 40px; height: 40px"
                            :src="item.image"
                            alt=""
                            srcset=""
                    />
                    <div style="font-size: 12px">{{ item.desc }}</div>
                </div>
            </Tooltip>
        </div>
        <Modal
                title="描述"
                v-model="showDesc"
                :closable="false"
                @on-cancel="onCloseContent"
                @on-ok="onCloseContent"
        >{{ content }}
        </Modal
        >
    </div>
</template>

<script>
    import {makeSgin} from "@/utils";
    import {getBaseUrl} from "../../utils";
    import {QueryPhoneCode} from "@/api/login";

    export default {
        name: "Home",
        data() {
            return {
                index: 0,
                tabSelected: "signin",
                loginCheck: false,
                teacherIndex: 0,
                t_system_index: 0,
                signup: {
                    username: "",
                    password: "",
                    userType: "",
                    nickName: "",
                    realName: "",
                    uuid: "",
                    code: "",
                },
                banners: [],
                teams: {
                    list: [],
                },
                c_supports: {
                    list: [{}],
                },
                d_supports: {
                    list: [{}],
                },
                t_mode: {
                    list: [],
                },
                t_system: {
                    list: [],
                },
                cooperation_process: {
                    list: [{}],
                },
                cooperation_case: {
                    list: [],
                },
                side: {
                    list: [],
                },
                signupRules: {
                    nickName: {required: true, message: "请输入昵称"},
                    // realName: {required: true, message: "请输入姓名"},
                    userType: {required: true, message: "请选择用户角色"},
                    username: {required: true, message: "请输入手机号"},
                    password: {required: true, message: "请输入密码"},
                    code: {required: true, message: "请输入验证码"},
                },
                signin: {
                    username: "",
                    password: "",
                    captchaPath: "",
                    uuid: "",
                    captcha: "",
                    studentFlag: "1"
                },
                signinRules: {
                    username: {required: true, message: "请输入手机号"},
                    password: {required: true, message: "请输入密码"}
                },
                seconds: 60,
                loadingsSignup: false,
                loadingsSignin: false,
                loadingVCode: false,
                successGetPhondeCode: true,
                showDesc: false,
                content: "",
            };
        },
        created() {
            this.getHomeWenAn();
            this.getCaptcha();
            this.prohibit();
        },
        methods: {
            goToDownload(){
                this.$Message.info('正在下载...');
                window.location.href = "https://wup-oss-1252338237.cos.ap-shanghai.myqcloud.com/api/20210325/3aa4a128e1dc43c693c90c9f1d7a27c8.exe?name=ChromeSetup.exe"
            },
            goToDownloadCancel(){
                this.$Message.info('已取消！');
            },
            onCloseContent() {
                this.showDesc = false;
                this.content = "";
            },
            onClickDesc(content) {
                this.content = content
                this.showDesc = true
            },
            async getVCode() {
                if (!this.signup.username) {
                    return this.$Message.error("请输入手机号");
                }
                this.loadingVCode = true;
                this.signup.uuid = this.getUuid();
                try {
                    const data = await QueryPhoneCode({
                        phone: this.signup.username,
                        uuid: this.signup.uuid,
                    });
                    if (data.code === 500) {
                        return this.$Message.error(data.msg || "手机验证码发送失败");
                    }
                    this.$Message.success("手机验证码发送成功");
                    this.successGetPhondeCode = false;
                    this.setinterval = setInterval(() => {
                        if (this.seconds <= 0) {
                            clearInterval(this.setinterval);
                            this.successGetPhondeCode = true;
                            this.seconds = 60;
                            return;
                        }
                        this.seconds--;
                    }, 1000);
                } catch (error) {
                    this.$Message.error("手机号发送失败/手机号已存在");
                } finally {
                    this.loadingVCode = false;
                }
            },
            // 获取验证码
            getCaptcha() {
                this.signin.uuid = this.getUuid();
                this.signin.captchaPath = getBaseUrl() + "/captcha.jpg?uuid=" + this.signin.uuid;
            },
            // 获取验证码
            jumpUrl(url) {
                window.open(url)
            },
            enterLogin(){
                this.handleSignin();
            },
            handleSignup() {
                this.tabSelected = "signup";
                this.$refs.signup.validate((valid) => {
                    if (valid) {
                        this._r.post("sys/register", this.signup).then((res) => {
                            if (res.code === 0) {
                                // 注册成功
                                this.$Message.success("注册成功！请登录");
                                this.tabSelected = "signin";
                              /*  this._r
                                    .post("sys/login", {
                                        username: this.signup.username,
                                        password: this.signup.password,
                                    })
                                    .then((res) => {
                                        if (res.code === 0) {
                                            // 登录成功
                                            this.$store.commit("setToken", res.token);
                                            this.$store.commit("setUserInfo", res.loginUser);
                                            this.$Message.success("登录成功！");
                                        } else {
                                            this.$Message.error(res.msg);
                                        }
                                        this.loadingsSignin = false;
                                    });*/
                            } else {
                                this.$Message.error(res.msg);
                            }
                        });
                    }
                });
            },
            getHomeWenAn() {
                this._r.get("open/api/homePage?sign=" + makeSgin()).then((res) => {
                    res.data.forEach((i) => {
                        switch (i.paramKey) {
                            case "HOME_PAGE_1":
                                this.banners = {
                                    ...i,
                                    list: JSON.parse(i.paramValue),
                                };
                                break;
                            case "HOME_PAGE_2":
                                this.teams = {
                                    ...i,
                                    list: JSON.parse(i.paramValue),
                                };
                                break;
                            case "HOME_PAGE_3":
                                this.c_supports = {
                                    ...i,
                                    list: JSON.parse(i.paramValue),
                                };
                                break;
                            case "HOME_PAGE_4":
                                this.d_supports = {
                                    ...i,
                                    list: JSON.parse(i.paramValue),
                                };
                                break;
                            case "HOME_PAGE_5":
                                this.t_mode = {
                                    ...i,
                                    list: JSON.parse(i.paramValue),
                                };
                                break;
                            case "HOME_PAGE_6":
                                this.t_system = {
                                    ...i,
                                    list: JSON.parse(i.paramValue),
                                };
                                break;
                            case "HOME_PAGE_7":
                                this.cooperation_process = {
                                    ...i,
                                    list: JSON.parse(i.paramValue),
                                };
                                break;
                            case "HOME_PAGE_8":
                                this.cooperation_case = {
                                    ...i,
                                    list: JSON.parse(i.paramValue),
                                };
                                break;
                            case "HOME_PAGE_10":
                                this.side = {
                                    ...i,
                                    list: JSON.parse(i.paramValue),
                                };
                                break;
                        }
                    });
                });
            },
            prohibit() {	// 禁用鼠标右击、F12
                if (process.env.NODE_ENV === 'development') {
                    return
                }
                document.oncontextmenu = function(){
                    return false;
                }
                document.onkeydown = function(e) {
                    if(e.keyCode==123){
                        return false
                    }
                };
            },
            handleSignin() {
             /*   if ( process.env.NODE_ENV !== 'development' ) {
                    if(navigator.userAgent.toLowerCase().indexOf("edg") != -1){
                        // this.$Message.info("sorry，请更换 谷歌浏览器 继续访问...");
                        this.loginCheck = true;
                        return
                    }
                    if(navigator.userAgent.toLowerCase().indexOf("chrome") == -1){
                        // this.$Message.info("sorry，请更换 谷歌浏览器 继续访问...");
                        this.loginCheck = true;
                        return
                    }
                }*/

                this.$refs.signin.validate((valid) => {
                    if (valid) {
                        this._r.post("sys/login", this.signin).then((res) => {
                            if (res.code === 0) {
                                // 登录成功
                                this.$store.commit("setToken", res.token);
                                this.setCookie("reqBaseUrl", process.env.VUE_APP_API_UR);
                                this.setCookie("token", res.token);
                                this.$store.commit("setUserInfo", res.loginUser);
                                this.$Message.success("登录成功！");
                            } else {
                                this.$Message.error(res.msg);
                                this.getCaptcha()
                            }
                            this.loadingsSignin = false;
                        });
                    }
                });
            },
            setCookie(name,value){
                let Days = 30;
                let exp = new Date();
                exp.setTime(exp.getTime() + Days*24*60*60*30);
                document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
            },
            getUuid() {
                let s = [];
                let hexDigits = "0123456789abcdef";
                for (let i = 0; i < 32; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
                var uuid = s.join("");
                return uuid;
            },
        },
    };
</script>

<style lang="scss">
    .card-item_header--image {
        width: 400px;
        height: 300px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }
    .home {
        position: relative;

        .home-banners {
            height: 666px;
        }

        .ivu-carousel-item {
            .demo-carousel {
                height: 666px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .login-panel {
            position: absolute;
            right: 10rem;
            top: 3rem;
            width: 20rem;
        }

        .home-section {
            text-align: center;

            .section-title {
                display: inline-block;
                font-size: 2rem;
                font-weight: bold;
                border-bottom: 2px solid #008184;
            }

            .section-desc {
                margin: 1rem 0;
            }
        }

        .teacher {
            background-color: #ffffff;
            padding: 2rem 1rem;
            height: 300px;

            &:hover {
                background-color: aliceblue;
            }

            img {
                width: 6rem;
                height: 6rem;
                border-radius: 100%;
                margin-bottom: 1rem;
            }

            .teacher-name {
                font-weight: bold;
                color: #000000;
                font-size: 1rem;
                margin-bottom: 0.5rem;
            }

            .teacher-desc {
                text-align: left;
                margin-top: 1rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }

        .t_mode-images {
            padding: 0.5rem;

            img {
                border-radius: 0.5rem;
                height: 230px;
                box-shadow: 0 0 0.5rem 0 rgba($color: #000000, $alpha: 0.1);
            }
        }

        .cooperation_case_image {
            width: 500px;
            height: 400px;
            border-radius: 0.5rem;
            box-shadow: 0 0 0.5rem 0 rgba($color: #ffffff, $alpha: 0.2);
        }

        .home-side {
            position: fixed;
            right: 30px;
            bottom: 100px;
            display: flex;
            width: 200px;
            flex-direction: column;
            text-align: center;

            .side-item {
                padding: 4px;
                cursor: pointer;
                background-color: rgba(255,255,255,0.2);

                & + .side-item {
                    margin-top: 0.5rem;
                }
            }
        }
    }
</style>
